import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { m as n } from "./tss-DN0acMKN.mjs";
const t = n()(({ transitions: e }, o, r) => ({
  hovered: {
    transition: e.create(["opacity"])
  },
  root: {
    "&:not(:focus-within, :hover)": {
      [`& .${r.hovered}`]: {
        opacity: 0,
        pointerEvents: "none"
      }
    }
  }
}));
function i({ children: e }) {
  const { classes: o } = t(void 0);
  return /* @__PURE__ */ s.jsx("div", { className: o.hovered, children: e });
}
function c({ children: e, forceHover: o }) {
  const { classes: r, cx: a } = t(void 0);
  return /* @__PURE__ */ s.jsx("div", { className: a({ [r.root]: !o }), "data-fabric-component": "Hoverable", children: e });
}
c.Hovered = i;
export {
  c as H,
  i as a
};
//# sourceMappingURL=hoverable-Ce46EoVE.mjs.map
